import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/aurelia-tokens.css';      // T1: variables --au-* (dark + light)
import './styles/aurelia-components.css';   // T1: clases .au-* (glass, botones, pills)
import './styles/glass.css';                // APP 2/20: vidrio aurora del mockup aprobado (.gl-*)
import { migrarAlmacen, desregistrarServiceWorker, recargarSiChunkPerdido, ArranqueSeguro } from './arranque'; // APP 2/17
import App from './App';

// APP 2/17: antes de pintar nada — llaves viejas fuera (una vez), sin service worker, chunk perdido → una recarga.
migrarAlmacen();
desregistrarServiceWorker();
recargarSiChunkPerdido();

// APP 2/20 Fase A: fuera --au-radio (nadie la leía); los radios CSS son --au-radius-sm/md/lg en aurelia-tokens.css.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><ArranqueSeguro><App /></ArranqueSeguro></React.StrictMode>);
